import React from "react";
import Select from "react-tailwindcss-select";

const TailwindSelect = ({ id, value, onChange, options, placeholder }) => {
  return (
    <Select
      classNames={{
        menu: "absolute z-10 w-full bg-white shadow-lg border border-slate-100 rounded py-1 mt-1.5 text-sm text-slate-700 dark:border-slate-800 dark:bg-slate-800  transition-all duration-300",
        menuButton: ({ isDisabled }) =>
          "flex text-md text-slate-800 dark:text-slate-100 border border-slate-300 outline-none rounded shadow-sm transition-all duration-300 focus:outline-none bg-white hover:border-slate-400 focus:border-majky-500 focus:ring focus:ring-majky-500/20  dark:bg-slate-800",
      }}
      id={id}
      value={value}
      primaryColor={"green"}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
    />
  );
};

export default TailwindSelect;
